function upsellComponent(productHandle) {
  return {
    upsellProduct: {},
    productAdded: false,
    isWorking: false,

    get productImage() {
      return this.upsellProduct.media[0].src;
    },

    get link() {
      return `${window.Shopify.routes.root}products/${productHandle}`;
    },

    get price() {
      return simplePrice(this.upsellProduct.variants[0].formattedPrice);
    },

    get comparePrice() {
      this.upsellProduct.variants[0].compareAtPrice ? this.upsellProduct.variants[0].compareAtPrice : null;
    },

    isVariantInCart() {
      const variantId = this.upsellProduct.variants[0].id.toString();
      const cartItems = this.$store.cart.cartData.items || [];
      this.productAdded = cartItems.some((item) => item.variant_id.toString() === variantId);
    },

    async addToCart() {
      if (this.isWorking) return;

      const { variants } = this.upsellProduct;
      const [selectedVariant] = variants;
      const simpleId = selectedVariant.id;

      try {
        this.isWorking = true;
        this.productAdded = true;
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'post',
          body: JSON.stringify({ items: [{ id: simpleId }] }),
          headers: { 'content-type': 'application/json' },
        });

        if (!res.ok) {
          let description = '';
          try {
            const data = await res.json();
            description = data?.description;
          } catch (e) {
            //
          }
          throw new Error(
            [`Failed to add to cart!`, description, `(status: ${res.status})`].filter(Boolean).join('\n'),
          );
        }

        this.$dispatch('update-and-open-cart', {
          noOpenAfterUpdate: window.CURRENT_TEMPLATE === 'cart',
        });
        this.isWorking = false;
      } catch (error) {
        this.productAdded = false;
        alert(error.message);
        this.isWorking = false;
        throw error;
      }
    },

    async init() {
      try {
        const upsellProductData = await fetchProductData(productHandle);
        this.upsellProduct = upsellProductData;
        this.isVariantInCart();
      } catch (error) {
        console.error('Upsell component init error:', error);
      }
    },
  };
}

document.addEventListener('alpine:init', () => {
  Alpine.data('upsellComponent', upsellComponent);
});
